var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeManabakhLogo = function SvgHomeManabakhLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.991 21.568v-4.035h3.038a4.036 4.036 0 0 0 4.042-4.034 4.036 4.036 0 0 0-4.041-4.035h-4.042v8.07l-4.041 4.034h-7.08v-4.035h7.08V5.414h8.098c4.466 0 8.097 3.625 8.097 8.085 0 4.459-3.63 8.084-8.097 8.084zM58.834 7.431l-4.041 4.035v6.067h-3.039V5.414h-8.098c-4.466 0-8.097 3.625-8.097 8.085v8.084h7.064l4.072-4.035h-7.08v-4.065a4.036 4.036 0 0 1 4.041-4.034h4.042v12.119h7.08l4.056-4.035zM1.163 6.416l4.041 4.035h7.08v3.033H8.258C3.79 13.484.16 17.11.16 21.57v2.017h4.041V21.57a4.036 4.036 0 0 1 4.042-4.035h8.097v-7.083L12.3 6.416zM33.537 17.534l-4.04 4.035H18.374V5.415l4.041-4.05v16.17zM56.814 5.414a2.018 2.018 0 1 0 0-4.035c-1.125 0-2.021.91-2.021 2.017 0 1.108.912 2.018 2.02 2.018M27.478 27.634a2.018 2.018 0 1 0 0-4.034 2.018 2.018 0 1 0 0 4.034M4.2 4.398a2.018 2.018 0 1 0 0-4.035c-1.124 0-2.02.91-2.02 2.018S3.09 4.398 4.2 4.398"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeManabakhLogo_svg__a)",
    d: "m127.882 27.75 6.123-6.113v-9.313c0-6.674-5.409-12.074-12.094-12.074h-16.347l-6.123 6.113h28.441z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeManabakhLogo_svg__b)",
    d: "M127.881 6.363A6.11 6.11 0 0 0 121.759.25h-9.861v6.113z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeManabakhLogo_svg__c)",
    d: "m97.267.25-6.123 6.113v9.313c0 6.674 5.41 12.074 12.094 12.074h16.347l6.123-6.113h-28.44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#homeManabakhLogo_svg__d)",
    d: "M97.266 21.637a6.11 6.11 0 0 0 6.122 6.112h6.457v-6.112z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m115.166 13.189-4.148-2.397a.951.951 0 0 0-1.428.82v4.777a.951.951 0 0 0 1.428.82l4.148-2.367a.953.953 0 0 0 0-1.653"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "homeManabakhLogo_svg__a",
    x1: 113.549,
    x2: 124.768,
    y1: 19.491,
    y2: 0.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "homeManabakhLogo_svg__b",
    x1: 111.897,
    x2: 127.882,
    y1: 3.306,
    y2: 3.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "homeManabakhLogo_svg__c",
    x1: 100.36,
    x2: 111.58,
    y1: 27.961,
    y2: 8.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "homeManabakhLogo_svg__d",
    x1: 97.271,
    x2: 109.855,
    y1: 24.697,
    y2: 24.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgHomeManabakhLogo;